<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Payment-Policy",
  path: "payment/policy",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
